module.exports = __webpack_public_path__ + "images/74ea0197117511d00f986da588fc2c67-Globus.jpg";